import { FolderId } from '../file';

export type ProjectChecklistId = string;

export enum ChecklistType {
  monthly = 'month',
  setup = 'setup',
}

export interface ProjectChecklistStepResponse {
  id: number;
  name: string;
  menuOrder: number;
  link?: string;
  description?: string;
}

export interface ProjectChecklistSectionResponse {
  id: number;
  name: string;
  menuOrder: number;
  steps: ProjectChecklistStepResponse[];
}

export interface ProjectChecklistResponse {
  id: ProjectChecklistId;
  name: string;
  description: string;
  type: ChecklistType;
  folderId: FolderId;
  serviceId: string;
  serviceName: string;
  sections: ProjectChecklistSectionResponse[];
  linkedWith: string[];
}

export const ChecklistTypeTitle: Record<ChecklistType, string> = {
  month: 'Recurring Template',
  setup: 'Setup Template',
};

export type CompactProjectChecklistResponse = Omit<ProjectChecklistResponse, 'sections'>;

export interface ProjectChecklistRequest {
  name: string;
  description: string;
  type: ChecklistType;
  folderId?: FolderId;
}

export const checklistStepTypes = [
  { label: 'Standard', value: 'standard' },
  { label: 'Note', value: 'note' },
];
